import { jsx } from "react/jsx-runtime";
const Twitter = ({ className = 'tw-text-neutral-light-800', size = 32 })=>/*#__PURE__*/ jsx("svg", {
        className: className,
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        children: /*#__PURE__*/ jsx("path", {
            d: "m19.534 3.811-.253.07c-1.465-1.233-3.387-1.163-5.012-.554-1.956.732-3.28 2.54-3.27 4.646-2.505-.21-4.7-1.48-6.186-3.555a1 1 0 0 0-1.685.092l.87.49-.87-.49v.002l-.002.003-.005.007-.012.024-.042.079a10.699 10.699 0 0 0-.536 1.261c-.288.82-.586 1.972-.6 3.267-.012 1.302.265 2.764 1.147 4.158.64 1.01 1.572 1.945 2.87 2.748-1.254.643-2.503.996-3.91.942a1 1 0 0 0-.517 1.877c3.477 1.895 7.356 2.597 10.792 1.6 3.893-1.132 7.107-4.063 8.335-8.433l.001-.004c.346-1.256.525-2.551.533-3.853.03-.068.075-.158.133-.274.08-.158.168-.33.267-.52.087-.168.181-.35.284-.553.397-.78.905-1.812 1.098-2.563A1 1 0 0 0 23 4.01v-.001a1 1 0 0 0-1.476-.88c-.653.316-1.269.484-1.99.682Z",
            fill: "none",
            className: "tw-fill-current"
        })
    });
const Twitter_Twitter = Twitter;
export default Twitter_Twitter;
